// @ts-nocheck

import palette from '../palette';

export const Odd = {
  isUp: palette.greenwinamax450,
  isDown: palette.red100,
  normal: palette.white,
};
